import _extends from "@babel/runtime/helpers/extends";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { BCP47_LANG_MAP, compatibleLang } from './utils';
import i18nString from './i18nString';
// 时间入参

var i18nIsZh = i18nString.i18nIsZh;
/**
 * 获取时间戳的小时
 * @param  {Number} [value]  语言
 * @return {Number}
 */
var getHours = function getHours(value) {
  var date = new Date(value);
  return date.getHours();
};

/**
 * 获取日期相关建立的专业化术语map 用于antd中的moment.js
 * @param  {String} [lang='zh-cn']  语言
 * param  {String} [key='format']  获取的类型
 * param  {Number} [special=0]  特殊类型
 * @return {String}
 */
var getI18nDateLocale = function getI18nDateLocale(lang, key, special) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  if (key === void 0) {
    key = 'format';
  }
  if (special === void 0) {
    special = 0;
  }
  var i18nDateLocaleMap = {
    'zh-cn': {
      format: 'YYYY-MM-DD HH:mm',
      formatHiddenTime: 'YYYY-MM-DD',
      sameDay: '今天',
      lastDay: '昨天',
      sameDayTime: '今天 ${time}',
      lastDayTime: '昨天 ${time}'
    },
    'zh-tw': {
      format: 'YYYY-MM-DD HH:mm',
      formatHiddenTime: 'YYYY-MM-DD',
      sameDay: '今天',
      lastDay: '昨天',
      sameDayTime: '今天 ${time}',
      lastDayTime: '昨天 ${time}'
    },
    // 英语
    en: {
      format: 'MM/DD/YYYY, HH:mm',
      formatHiddenTime: 'MM/DD/YYYY',
      sameDay: 'Today',
      lastDay: 'Yesterday',
      sameDayTime: 'Today at ${time}',
      lastDayTime: 'Yesterday at ${time}'
    },
    // 阿拉伯语
    ar: {
      format: 'YYYY-MM-DD HH:mm',
      formatHiddenTime: 'YYYY-MM-DD',
      sameDay: 'اليوم',
      lastDay: 'أمس',
      sameDayTime: 'اليوم عند الساعة ${time}',
      lastDayTime: 'اليوم عند الساعة ${time}'
    },
    // 德语
    de: {
      format: 'DD.MM.YYYY, HH:mm',
      formatHiddenTime: 'DD.MM.YYYY',
      sameDay: 'Heute',
      lastDay: 'Gestern',
      sameDayTime: 'Heute um ${time} Uhr',
      lastDayTime: 'Gestern um ${time} Uhr'
    },
    // 俄语
    ru: {
      format: 'DD.MM.YYYY, HH:mm',
      formatHiddenTime: 'DD.MM.YYYY',
      sameDay: 'Сегодня',
      lastDay: 'Вчера',
      sameDayTime: 'Сегодня, в ${time}',
      lastDayTime: 'Вчера, в ${time}'
    },
    // 法语
    fr: {
      format: 'DD/MM/YYYY HH:mm',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'Aujourd’hui',
      lastDay: 'Hier',
      sameDayTime: 'Aujourd’hui à ${time}',
      lastDayTime: 'Hier à ${time}'
    },
    // 韩语
    ko: {
      format: 'YYYY. MM. DD. HH:mm',
      formatHiddenTime: 'YYYY. MM. DD.',
      sameDay: '오늘',
      lastDay: '어제',
      sameDayTime: '오늘 ${time}',
      lastDayTime: '어제 ${time}'
    },
    // 葡萄牙语
    pt: {
      format: 'DD/MM/YYYY, HH:mm',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'Hoje',
      lastDay: 'Ontem',
      sameDayTime: 'Hoje às ${time}',
      lastDayTime: 'Ontem às ${time}'
    },
    // 日语
    ja: {
      format: 'YYYY/MM/DD HH:mm',
      formatHiddenTime: 'YYYY/MM/DD',
      sameDay: '今日',
      lastDay: '昨日',
      sameDayTime: '今日 ${time}',
      lastDayTime: '昨日 ${time}'
    },
    // 泰语
    th: {
      format: 'DD/MM/YYYY, HH:mm',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'วันนี้',
      lastDay: 'เมื่อวาน',
      sameDayTime: 'วันนี้ เวลา ${time}',
      lastDayTime: 'เมื่อวานนี้ เวลา ${time}'
    },
    // 土耳其语
    tr: {
      format: 'DD.MM.YYYY, HH:mm',
      formatHiddenTime: 'DD.MM.YYYY',
      sameDay: 'Bugün',
      lastDay: 'Dün',
      sameDayTime: 'Bugün saat ${time}',
      lastDayTime: 'Dün ${time}'
    },
    // 西班牙语
    // hour为1特殊展示
    es: {
      format: 'DD/MM/YYYY, HH:mm',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'Hoy',
      lastDay: 'Ayer',
      sameDayTime: special ? 'Hoy a la ${time}' : 'Hoy a las ${time}',
      lastDayTime: special ? 'Ayer a la ${time}' : 'Ayer a las ${time}'
    },
    // 印尼语
    id: {
      format: 'DD/MM/YYYY, HH.mm',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'Hari ini',
      lastDay: 'Kemarin',
      sameDayTime: 'Hari ini pukul ${time}',
      lastDayTime: 'Kemarin pukul ${time}'
    },
    // 越南语
    vi: {
      format: 'HH:mm DD/MM/YYYY',
      formatHiddenTime: 'DD/MM/YYYY',
      sameDay: 'Hôm nay',
      lastDay: 'Hôm qua',
      sameDayTime: 'Hôm nay lúc ${time}',
      lastDayTime: 'Hôm qua lúc ${time}'
    },
    // 菲律宾语在BCP47中为fil
    tl: {
      format: 'MM/DD/YYYY, HH:mm',
      formatHiddenTime: 'MM/DD/YYYY',
      sameDay: 'Ngayong araw',
      lastDay: 'Kahapon',
      sameDayTime: '${time} ngayong araw',
      lastDayTime: '${time} kahapon'
    }
  };

  // 兼容lang不在map中的情况
  if (i18nDateLocaleMap[lang]) {
    return i18nDateLocaleMap[lang][key];
  } else {
    return i18nDateLocaleMap['zh-cn'][key];
  }
};

/**
 * 获取当前语种的日期通用格式
 * @param  {String} [lang='zh-cn']  语言
 * @param  {Boolean} [ifShowTime=true]  语言
 * @return {String}
 */
var i18nGetLangFormat = function i18nGetLangFormat(lang, ifShowTime) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  if (ifShowTime === void 0) {
    ifShowTime = true;
  }
  // lang兼容处理
  lang = compatibleLang(lang);
  return getI18nDateLocale(lang, ifShowTime ? 'format' : 'formatHiddenTime');
};

// padStart 也可 https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
// 兼容性考虑，先自己实现下
function pad(val, len) {
  var valTmp = String(val);
  var lenTmp = len || 2;
  while (valTmp.length < lenTmp) {
    valTmp = "0" + valTmp;
  }
  return valTmp;
}

/**
 * 时间戳转为日期的格式
 * @param value
 * @param format  可选 默认 'yyyy-MM-dd HH:mm'
 * @returns {*}
 */
var timestamp2date = function timestamp2date(value, format) {
  if (format === void 0) {
    format = 'yyyy-MM-dd HH:mm';
  }
  if (value && typeof value === 'string') {
    value = Number(value);
  }
  if (!value || Number.isNaN(value)) return '--';
  var maps = {
    yyyy: function yyyy(date) {
      return date.getFullYear();
    },
    MM: function MM(date) {
      return pad(date.getMonth() + 1);
    },
    dd: function dd(date) {
      return pad(date.getDate());
    },
    HH: function HH(date) {
      return pad(date.getHours());
    },
    mm: function mm(date) {
      return pad(date.getMinutes());
    },
    ss: function ss(date) {
      return pad(date.getSeconds());
    }
  };
  var trunk = new RegExp(Object.keys(maps).join('|'), 'g');
  value = new Date(value || +new Date());
  return format.replace(trunk, function (capture) {
    return maps[capture] ? maps[capture](value) : '';
  });
};

/**
 * 国际化处理日期
 * @param  {Number} value         要转化的数值
 * @param  {String} [lang='zh-cn']  值不存在时，显示的内容
 * @param  {String} [formatStr='yyyy-MM-dd HH:mm']  中文时的时间日期格式
 * @param  {Object} [options]
 * @return {String}
 */
var i18nDateTime = function i18nDateTime(timestamp, lang, formatStr, options) {
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  if (formatStr === void 0) {
    formatStr = 'yyyy-MM-dd HH:mm';
  }
  if (!timestamp || Number.isNaN(timestamp)) return '--';

  // lang兼容处理
  lang = compatibleLang(lang);

  // 传入formatStr不是字符串
  if (typeof formatStr !== 'string') {
    formatStr = 'yyyy-MM-dd HH:mm';
  }

  // 兼容Intl不存在的情况
  if (typeof Intl === 'undefined' || i18nString.i18nIsZh(lang) || i18nIsZh(lang)) {
    return timestamp2date(timestamp, formatStr);
  }
  if (timestamp && typeof timestamp === 'string') {
    timestamp = Number(timestamp);
  }
  var basicOption = {
    hour12: false,
    // 使用24小时制
    calendar: 'gregory' // 使用格里高利立
  };
  if (formatStr.includes('yyyy')) {
    basicOption.year = 'numeric';
  }
  if (formatStr.includes('MM')) {
    basicOption.month = '2-digit';
  }
  if (formatStr.includes('dd')) {
    basicOption.day = '2-digit';
  }
  if (formatStr.includes('HH')) {
    basicOption.hour = '2-digit';
  }
  if (formatStr.includes('mm')) {
    basicOption.minute = '2-digit';
  }
  if (formatStr.includes('ss')) {
    basicOption.second = '2-digit';
  }

  // @ts-expect-error
  var formatter = new Intl.DateTimeFormat(BCP47_LANG_MAP[lang] || 'zh-Hans-CN', _extends({}, basicOption, options));
  return formatter.format(timestamp);
};

/**
 * 判断两个时间戳是否跨年了
 * @param  {[type]} startTime [description]
 * @param  {[type]} endTime   [description]
 * @return {[type]}           [description]
 */
var crossYears = function crossYears(startTime, endTime) {
  return new Date(endTime).getFullYear() !== new Date(startTime).getFullYear();
};

/**
 * @description 时间戳转为固定日期格式：今年显示'MM-dd HH:mm', 非今年显示'yyyy-MM-dd HH:mm'
 * @param {Number} value - 时间
 * @param {String} [formatFromMonth='MM-dd HH:mm'] - 时间格式
 * @param {Boolean} [abbr=false] - 是否缩写成"昨天", "今天"
 * @param {Boolean} [hidenAbbrTime=false] - 是否隐藏"昨天", "今天"后的日期
 * @param {Boolean} [lang='zh-cn'] - 语言
 * @return {String} 格式后的时间
 */
var i18nTimestamp2fixedDate = function i18nTimestamp2fixedDate(value, formatFromMonth, abbr, hidenAbbrTime, lang) {
  if (formatFromMonth === void 0) {
    formatFromMonth = 'MM-dd HH:mm';
  }
  if (abbr === void 0) {
    abbr = false;
  }
  if (hidenAbbrTime === void 0) {
    hidenAbbrTime = false;
  }
  if (lang === void 0) {
    lang = 'zh-cn';
  }
  // lang兼容处理
  lang = compatibleLang(lang);
  if (value && typeof value === 'string') {
    value = Number(value);
  }
  if (!value || Number.isNaN(value)) return '--';

  // 传入formatStr不是字符串
  if (typeof formatFromMonth !== 'string') {
    formatFromMonth = 'MM-dd HH:mm';
  }
  var nowTime = new Date().getTime();
  // 跨年
  if (crossYears(value, nowTime)) {
    return i18nDateTime(value, lang, "yyyy-" + formatFromMonth);
  } else if (abbr) {
    var nowYear = new Date().getFullYear();
    var nowMonth = new Date().getMonth();
    var nowDate = new Date().getDate();
    var newValue = new Date(value);
    var formatFromHour = formatFromMonth.replace(/^.+HH/, 'HH');
    // 同日
    if (nowYear === newValue.getFullYear() && nowMonth === newValue.getMonth() && nowDate === newValue.getDate()) {
      if (hidenAbbrTime) {
        return getI18nDateLocale(lang, 'sameDay');
      } else {
        return getI18nDateLocale(lang, 'sameDayTime', lang === 'es' && getHours(value) === 1 ? 1 : 0).replace('${time}', i18nDateTime(value, lang, formatFromHour));
      }
      // 昨日
    } else if (nowYear === newValue.getFullYear() && nowMonth === newValue.getMonth() && nowDate === newValue.getDate() + 1) {
      if (hidenAbbrTime) {
        return getI18nDateLocale(lang, 'lastDay');
      } else {
        return getI18nDateLocale(lang, 'lastDayTime', lang === 'es' && getHours(value) === 1 ? 1 : 0).replace('${time}', i18nDateTime(value, lang, formatFromHour));
      }
    }
  }
  // 格式化日期
  return i18nDateTime(value, lang, formatFromMonth);
};
var i18nDate = {
  i18nDateTime: i18nDateTime,
  i18nTimestamp2fixedDate: i18nTimestamp2fixedDate,
  i18nGetLangFormat: i18nGetLangFormat
};
export default i18nDate;